










































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { PropSync } from 'vue-property-decorator';
import { Typing } from '@/modules/tickets/shared/domain/typing';
import FormNavigationButtons from '@/components/tickets/tickets-form/common/FormNavigationButtons.vue';
import * as rules from '@/modules/shared/shared/domain/rules';
import { LinkManagementData } from '@/modules/tickets/incidents/link-management/domain/link-management-data';
import AttachmentZone from '@/modules/tickets/incidents/shared/components/AttachementZone.vue';
import { Attachment } from '@/modules/tickets/incidents/shared/domain/attachment';
import AttachmentSelection from '@/modules/tickets/incidents/shared/components/AttachmentSelection.vue';
import { NetworkSecurityInternetIncidentData } from '@/modules/tickets/incidents/network-security-internet/domain/network-security-internet-incident-data';
import { ProcessingAndManagedManagementData } from '@/modules/tickets/incidents/processing-and-managed-management/domain/processing-and-managed-management-data';
import {
    ALLOWED_EXTENSIONS,
    isValidFile,
} from '@/modules/shared/shared/domain/functions/allowed-files';
import PhoneField from '@/modules/shared/shared/components/PhoneField.vue';

@Component({
    name: 'processing-and-managed-management-general-information',
    components: { PhoneField, AttachmentSelection, AttachmentZone, FormNavigationButtons },
})
export default class ProcessingAndManagedManagementGeneralInformation extends Vue {
    $refs!: {
        form: any;
    };

    private resetKey = 0;

    private isFormValid: boolean = true;

    private rules: any = rules;

    validateStep() {
        if (this.$refs.form.validate()) {
            this.$emit('nextStep');
        }
    }

    @PropSync('valuesOfForm', { required: true })
    formValues!: {
        generalInformation: ProcessingAndManagedManagementData;
        categoriesTypings: Typing[];
    };

    private readonly validExtensions = ALLOWED_EXTENSIONS;

    get availableFiles() {
        return [...this.validExtensions].join(',');
    }

    get validFile() {
        if (this.formValues.generalInformation.attachment) {
            return isValidFile(this.formValues.generalInformation.attachment);
        }
        return true;
    }
}
